import { Tab, Tabs } from "@mui/material";
import { Vocabulary } from "../../Utils/Vocabulary";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import ClientsTable from "./ClientsTable";
import Filters from "../Widgets/Filters";
import { Filter } from "../../Utils/Types";
import { EComponentTypes } from "../../Utils/Enums";
import * as yup from "yup";
import useCustomMemo from "../../Hooks/useCustomMemo";
import { getData } from "../../Services/getData";
import { endpoints } from "../../Utils/UrlEnum";
import { toast } from "react-toastify";
import { ClientModel } from "../../Utils/Models";
import genericStyles from "../../Styles/genericStyles.module.css";
import LegalClientTable from "./LegalClientTable";

export default function ClientMainPage() {
  const [value, setValue] = useState(0);
  const [tags, setTags] = useState();
  const memo = useCustomMemo();
  const clientCategories = memo?.storage.clientCategories || [];

  useEffect(() => {
    getData(`${endpoints.predefined}`)
      .then((res) => {
        setTags(res.data);
      })
      .catch((err) => {
        toast.error(err);
      });
  }, []);

  const filters: Filter[] = [
    {
      property: "name",
      label: Vocabulary.name,
      type: EComponentTypes.TEXT,
      validation: yup.string(),
      defaultValue: null,
    },
    {
      property: "companyName",
      label: Vocabulary.companyName,
      type: EComponentTypes.TEXT,
      validation: yup.string(),
      defaultValue: null,
    },
    {
      property: "email",
      label: Vocabulary.email,
      type: EComponentTypes.TEXT,
      validation: yup.string(),
      defaultValue: null,
    },
    {
      property: "phone",
      label: Vocabulary.phone,
      type: EComponentTypes.TEXT,
      validation: yup.string(),
      defaultValue: null,
    },
    {
      property: "category",
      label: Vocabulary.category,
      type: EComponentTypes.AUTOCOMPLETE,
      validation: yup.mixed().nullable(),
      defaultValue: null,
      options: clientCategories,
      autocompleteFilterProperty: "_id",
    },
    {
      property: "tags",
      label: Vocabulary.tags,
      type: EComponentTypes.AUTOCOMPLETE,
      validation: yup.mixed().nullable(),
      defaultValue: null,
      options: tags,
      autocompleteFilterProperty: "_id",
    },
    {
      property: "fiscalCode",
      label: Vocabulary.fiscalCode,
      type: EComponentTypes.TEXT,
      validation: yup.string(),
      defaultValue: null,
    },
    {
      property: "contactDate",
      label: Vocabulary.contactDate,
      type: EComponentTypes.DATE_PICKER,
      validation: yup.string().required(Vocabulary.requiredField),
      defaultValue: null,
    },
  ];

  const client = new ClientModel();

  const customClientFilter = {
    name: client.name,
    companyName: client.companyName,
    category: client.category,
    periodicity: client.periodicity,
    email: client.email,
    phone: client.phone,
    address: client.address,
    locations: client.locations,
  };

  function handleChangeValue(event: React.SyntheticEvent, newValue: number) {
    setValue(newValue);

    const url = new URL(window.location.href);
    url.searchParams.set("type", newValue === 1 ? "legal" : "physical");

    // This updates the URL without reloading the page
    window.history.pushState({}, "", url);
  }

  async function syncClients(reloadState: Dispatch<SetStateAction<boolean>>) {
    try {
      await getData(`${endpoints.client.main}/sync-woocommerce-customers`);
      reloadState(true);
    } catch (error) {
      toast.error(error);
    }
  }

  function showInformation() {
    switch (value) {
      case 0:
        return <ClientsTable syncClients={syncClients} />;
      case 1:
        return <LegalClientTable syncClients={syncClients} />;
      default:
        break;
    }
  }

  return (
    <div className={genericStyles.mainContainer}>
      <Filters filters={filters} customFilterModel={customClientFilter} />
      <Tabs value={value} onChange={handleChangeValue} textColor="inherit">
        <Tab label={Vocabulary.physicalPerson} />
        <Tab label={Vocabulary.legalPerson} />
      </Tabs>
      {showInformation()}
      <div style={{ marginTop: 20, marginBottom: 20 }}></div>
    </div>
  );
}
